// src/js/components/collection-filters.js
var CollectionFilters = class extends HTMLElement {
  connectedCallback() {
    this.refreshAccessibility();
    if (this.eventsBound) return;
    this.eventsBound = true;
    this.addEventListener("click", (event) => {
      if (event.target.closest("[toggle-filter-display]")) {
        this.setOpen(!this.classList.contains("is-active"));
      } else if (event.target.closest("[toggle-overlay-blur]")) {
        this.setOpen(false);
      }
    });
    this.addEventListener("keydown", (event) => {
      if (!this.classList.contains("is-active")) return;
      if (event.key === "Escape") {
        event.preventDefault();
        event.stopPropagation();
        this.setOpen(false);
      } else if (event.key === "Tab") {
        const elements = Array.from(this.querySelector("[filters-drawer]").querySelectorAll(
          'button, a[href], input, select, textarea, [tabindex="0"]'
        )).filter((el) => {
          if (el.disabled || el.tabIndex < 0 || el.closest("[inert]") || !el.getClientRects().length) return false;
          if (el.type === "radio" && el.name) {
            const group = Array.from(this.querySelectorAll('input[type="radio"]')).filter((radio) => radio.name === el.name);
            return el === (group.find((radio) => radio.checked) || group[0]);
          }
          return true;
        });
        const first = elements[0];
        const last = elements[elements.length - 1];
        if (event.shiftKey && (document.activeElement === first || document.activeElement === this.querySelector("[filters-drawer]"))) {
          event.preventDefault();
          last?.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first?.focus();
        }
      }
    });
  }
  refreshAccessibility() {
    const drawer = this.querySelector("[filters-drawer]");
    const open = this.classList.contains("is-active");
    drawer.inert = !open;
    drawer.setAttribute("aria-hidden", String(!open));
    this.querySelector(".filter-opener__button").setAttribute("aria-expanded", String(open));
    this.querySelectorAll("[toggle-filter-btn]").forEach((button, index) => {
      const panel = button.parentElement.querySelector("[toggle-filter-panel]");
      panel.id = `${drawer.id}-group-${index}`;
      button.setAttribute("aria-controls", panel.id);
      button.setAttribute("aria-expanded", String(button.classList.contains("is-open")));
      panel.inert = !button.classList.contains("is-open");
      panel.setAttribute("aria-hidden", String(panel.inert));
    });
  }
  setOpen(open) {
    this.classList.toggle("is-active", open);
    this.querySelector("[toggle-overlay-blur]").classList.toggle("is-active", open);
    document.body.classList.toggle("has-active-modal", open);
    this.refreshAccessibility();
    (open ? this.querySelector(".filter-close") : this.querySelector(".filter-opener__button"))?.focus();
  }
};
if (!customElements.get("collection-filters")) customElements.define("collection-filters", CollectionFilters);
if (!customElements.get("filters-group")) {
  class FiltersGroup extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      if (this.eventsBound) return;
      this.eventsBound = true;
      this.filterUrls = [];
      this.filtersType = this.dataset.type;
      this.initializeFilterUrls();
      this.initializeSelectors();
      this.initializeFilterEvents();
    }
    initializeFilterUrls() {
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.forEach((value, key) => {
        const encodeValue = encodeURIComponent(value);
        this.filterUrls.push(`${key}=${encodeValue}`);
      });
    }
    initializeSelectors() {
      this.filtersSelectors = {
        toggleBtn: "[toggle-filter-btn]",
        toggleContent: "[toggle-filter-panel]",
        form: "[filters-form]",
        filterDrawer: "[filters-drawer]",
        overlay: "[toggle-overlay-blur]",
        toggleFilters: "[toggle-filter-display]",
        filtersCheckbox: "[filters-checkbox]",
        submitFilterBtn: "[submit-filters-btn]",
        containerTemplate: "[container-template]",
        loader: "main-loader",
        removeFilterBtn: "[filter-remove-btn]",
        removeFilterAllbtn: "[filter-remove-all-btn]",
        sortbySelect: "[sort-by-select]",
        filtersRadioSort: "[filters-radio-sort]",
        drawerOpner: "[filter-drawer-opener]",
        drawerCloseBtn: "[filter-drawer-close]"
      };
      Object.entries(this.filtersSelectors).forEach(([key, value]) => {
        this[key] = this.querySelector(value);
      });
      this.filterToggleBtns = this.querySelectorAll(this.filtersSelectors.toggleBtn);
      this.removeFilterBtn = this.querySelectorAll(this.filtersSelectors.removeFilterBtn);
      this.removeFilterAllbtn = this.closest("collection-filters").querySelectorAll(this.filtersSelectors.removeFilterAllbtn);
      this.toggleFilters = document.querySelectorAll(this.filtersSelectors.toggleFilters);
      this.filtersCheckboxes = this.querySelectorAll(this.filtersSelectors.filtersCheckbox);
      this.filtersRadioSort = this.querySelectorAll(this.filtersSelectors.filtersRadioSort);
      this.sortbySelect = document.querySelector(this.filtersSelectors.sortbySelect);
      this.drawerOpner = document.querySelector(this.filtersSelectors.drawerOpner);
      this.drawerCloseBtn = document.querySelector(this.filtersSelectors.drawerCloseBtn);
      this.filterDrawer = document.querySelector(this.filtersSelectors.filterDrawer);
      this.overlay = document.querySelector(this.filtersSelectors.overlay);
      this.loader = document.querySelector(this.filtersSelectors.loader);
    }
    initializeFilterEvents() {
      this.filterToggleBtns?.forEach((btn) => {
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          this.toggleFilterPanel(btn);
        });
      });
      this.submitFilterBtn?.addEventListener("click", () => {
        console.log("APPLY FILTERS");
      });
      this.sortbySelect?.addEventListener("change", (e) => {
        this.sortBy(e);
      });
      this.filtersRadioSort?.forEach((input) => {
        input?.addEventListener("input", (e) => {
          this.sortBy(e);
        });
      });
      this.filtersCheckboxes?.forEach((input) => {
        input.addEventListener("input", () => {
          if (this.filterDrawer && (this.filtersType === "drawer" || window.innerWidth <= 864)) {
            this.toggleFilterDrawer();
          }
          this.toggleLoader();
          this.handleURL(input);
        });
      });
      this.removeFilterAllbtn?.forEach((btn) => {
        btn?.addEventListener("click", () => {
          this.filterUrls = [];
          this.handleURL();
        });
      });
      if (this.filterForm) {
        const debounce = (func, wait) => {
          let timeout;
          return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
              func(...args);
            }, wait);
          };
        };
        this.filterForm?.addEventListener("input", this.debouncedOnSubmit = debounce((event) => {
        }, 500));
      }
      this.addEventListener("priceFilter", (e) => {
        const inputLte = e.detail.inputLte;
        const inputGte = e.detail.inputGte;
        if (inputLte, inputGte) {
          this.toggleLoader();
          this.handlePriceFilter(inputLte, inputGte);
        }
      });
      this.addEventListener("removeFilter", (e) => {
        const filterPram = e.detail.button.getAttribute("data-param");
        const filterValue = e.detail.button.getAttribute("data-value");
        if (filterPram) {
          this.toggleLoader();
          this.handleRemoveURL(filterPram, filterValue);
        }
      });
      this.drawerCloseBtn?.addEventListener("click", () => {
        this.toggleFilterDrawer();
      });
    }
    sortBy(e) {
      this.toggleLoader();
      this.filterUrls = this.filterUrls.filter((url) => !url.startsWith("sort_by="));
      const sortByValue = `sort_by=${e.target.value}`;
      this.filterUrls.push(sortByValue);
      this.updateUrl();
    }
    handlePriceFilter(inputLte, inputGte) {
      this.filterUrls = this.filterUrls.filter((url) => !url.startsWith(`${inputLte.name}=`) && !url.startsWith(`${inputGte.name}=`));
      if (inputLte.value !== null) {
        this.filterUrls.push(`${inputLte.name}=${inputLte.value}`);
      }
      if (inputGte.value !== null) {
        this.filterUrls.push(`${inputGte.name}=${inputGte.value}`);
      }
      this.updateUrl();
    }
    handleRemoveURL(pram, value) {
      const filterEncodeValue = `${pram}=${encodeURIComponent(value)}`;
      this.filterUrls = this.filterUrls.filter((url) => !url.startsWith(`${filterEncodeValue}`));
      this.updateUrl();
    }
    handleURL(input) {
      const filterUrl = input?.getAttribute("value");
      const filterUrlName = input?.getAttribute("name");
      const filterEncodeValue = `${filterUrlName}=${encodeURIComponent(filterUrl)}`;
      if (input && input.checked) {
        if (!this.filterUrls.includes(filterEncodeValue)) {
          this.filterUrls.push(filterEncodeValue);
        }
      } else {
        const filterDecodeValue = `${filterUrlName}=${decodeURIComponent(filterUrl)}`;
        this.filterUrls = this.filterUrls.filter((url) => url !== filterEncodeValue && url !== filterDecodeValue);
      }
      this.updateUrl();
    }
    updateUrl() {
      const collectionHandle = window.location.pathname.split("/").pop();
      this.filterUrls = this.filterUrls.filter((url) => !url.startsWith("page="));
      const filterQueryString = this.filterUrls.join("&");
      let updatedUrl = `${collectionHandle}?${filterQueryString}`;
      window.history.replaceState({}, "", updatedUrl);
      this.fetchProducts();
    }
    async fetchProducts() {
      const controller = this.closest("collection-filters");
      controller.filterRequest?.abort();
      const request = new AbortController();
      controller.filterRequest = request;
      const apiUrl = `${this.dataset.url}&${this.filterUrls.join("&")}`;
      try {
        const response = await fetch(apiUrl, { signal: request.signal });
        const text = await response.json();
        if (request.signal.aborted) return;
        const firstKey = Object.keys(text)[0];
        const htmlString = text[firstKey];
        const parser = new DOMParser();
        const textDoc = parser.parseFromString(htmlString, "text/html");
        const focusedId = controller.contains(document.activeElement) ? document.activeElement.id : "";
        const focusWasInDrawer = controller.querySelector("[filters-drawer]").contains(document.activeElement);
        this.containerTemplateSource = textDoc.querySelector(this.filtersSelectors.containerTemplate);
        this.containerTemplate = document.querySelector(this.filtersSelectors.containerTemplate);
        if (this.containerTemplate && this.containerTemplateSource) {
          this.containerTemplate.outerHTML = this.containerTemplateSource.outerHTML;
        }
        this.filtersGroupDrawerSource = textDoc.querySelector(".col-filters-drawer");
        this.filtersGroupDrawer = document.querySelector(".col-filters-drawer");
        if (this.filtersGroupDrawer && this.filtersGroupDrawerSource) {
          this.filtersGroupDrawer.outerHTML = this.filtersGroupDrawerSource.outerHTML;
        }
        const sourceCount = textDoc.querySelector(".col-filter__head > div > h2");
        const targetCount = controller.querySelector(".col-filter__head > div > h2");
        if (sourceCount && targetCount) targetCount.textContent = sourceCount.textContent;
        const sortControl = controller.querySelector("[data-collection-sort]");
        const sourceSort = textDoc.querySelector("[data-collection-sort]");
        if (sortControl && sourceSort) sortControl.value = sourceSort.value;
        controller.refreshAccessibility();
        if (focusWasInDrawer && controller.classList.contains("is-active")) {
          const restored = focusedId && document.getElementById(focusedId);
          (restored && !restored.disabled && !restored.closest("[inert]") ? restored : controller.querySelector(".filter-close")).focus();
        }
        this.toggleLoader();
      } catch (error) {
        if (error.name === "AbortError") return;
        console.error("Error fetching products:", error);
        alert("There was an error fetching products. Please try again.");
        location.reload();
      }
    }
    toggleFilterPanel(btn) {
      const isOpen = btn.classList.contains("is-open");
      btn.classList.toggle("is-open", !isOpen);
      btn.setAttribute("aria-expanded", String(!isOpen));
      const togglePanel = btn.parentNode.querySelector(this.filtersSelectors.toggleContent);
      if (togglePanel) {
        togglePanel.inert = isOpen;
        togglePanel.setAttribute("aria-hidden", String(isOpen));
        togglePanel.classList.toggle("is-open", !isOpen);
        if (isOpen) {
          togglePanel.style.setProperty("--filter-scroll-height", "0px");
        } else {
          togglePanel.style.setProperty("--filter-scroll-height", `${togglePanel.scrollHeight + 2}px`);
        }
      }
    }
    toggleFilterDrawer() {
      const controller = this.closest("collection-filters");
      controller.setOpen(!controller.classList.contains("is-active"));
    }
    toggleLoader() {
    }
  }
  customElements.define("filters-group", FiltersGroup);
}
if (!customElements.get("facets-remove")) {
  class FacetsRemove extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("click", (e) => {
        e.preventDefault();
        const filterGroup = document.querySelector("filters-group");
        const button = this.querySelector("a");
        const customEvent = new CustomEvent("removeFilter", { detail: { button } });
        filterGroup.dispatchEvent(customEvent);
      });
    }
  }
  customElements.define("facets-remove", FacetsRemove);
}
var PriceRanges = class extends HTMLElement {
  constructor() {
    super();
    this.debounceTimeout = null;
    this.selectors = {
      inputLte: "[input-price-lte]",
      inputGte: "[input-price-gte]",
      inputs: "input"
    };
    this.init();
  }
  init() {
    this.inputs = this.querySelectorAll(this.selectors.inputs);
    this.inputGte = this.querySelector(this.selectors.inputGte);
    this.inputLte = this.querySelector(this.selectors.inputLte);
    this.inputs?.forEach((input) => {
      input?.addEventListener("input", () => {
        this.handleInput(input);
      });
    });
  }
  handleInput(input) {
    const min = parseFloat(input.getAttribute("min"));
    const max = parseFloat(input.getAttribute("max"));
    let value = input.value.trim().replace(/[^\d.]/g, "");
    value = value === "" ? "" : Math.min(max, Math.max(min, parseFloat(value)));
    input.value = value;
    this.debouncedTriggerPriceFilter();
  }
  debouncedTriggerPriceFilter() {
    clearTimeout(this.debounceTimeout);
    this.debounceTimeout = setTimeout(() => {
      this.triggerPriceFilter();
    }, 700);
  }
  triggerPriceFilter() {
    const filterGroup = document.querySelector("filters-group");
    const customEvent = new CustomEvent("priceFilter", { detail: { inputGte: this.inputGte, inputLte: this.inputLte } });
    filterGroup.dispatchEvent(customEvent);
  }
};
customElements.define("price-ranges", PriceRanges);
